/**
 * @file 问一问统一日志统计功能函数
 * @author iknow-fe
 */

import {Logger} from '@baidu/knowledge-logger';
const isDebug = false; // 测试抓包时用
const LOG_URL = 'https://power.baidu.com/m/static/common/ui/log/log.gif';
// 测试环境-上报地址
// const LOG_URL = 'http://iknow-rdtest02.bcc-bdbl.baidu.com:8999/m/static/common/ui/log/log.gif';
// 日志打点使用defer方式请求
// http://wiki.baidu.com/pages/viewpage.action?pageId=1283071412

// 模块打点实例，存放全局key
const logger = new Logger({
    logUrl: LOG_URL
});
let gLogOpt = {
    module: 'pc-lvlin',
    pname: 'lvlin',
    log_version: '2.0',
    page: window.location.pathname || '',
    session_id: +new Date() + Math.random().toString().substring(2)
};

if (isDebug) {
    gLogOpt.dev_debug = 1;
}

// 添加模块全局key
logger.addKey(gLogOpt);

const beforeSend = (data, allKey) => {
    let params = {
        t: +new Date()
    };

    const sendData = {...params, ...allKey, ...data};
    if (!sendData.page) {
        sendData.page = 'pc-lvlin';
    }
    return sendData;
};
logger.hook('beforeSend', beforeSend);

export default logger;
